export default __webpack_public_path__ + "static/media/352.cdb8415a.svg";